module.exports = __webpack_public_path__ + "assets/img/subscrubenull.1ef77d52.png";